import { t, type MessageKey } from '../i18n/index.ts';

/**
 * The chat assistant's fixed phrases travel as short codes ("bot:ask", "choice:yes") so that the
 * visitor and the team each read them in their own language. This turns a stored message into
 * who seems to say it and what it says.
 */
export type ChatAuthor = 'visitor' | 'staff' | 'system' | 'bot';

const BOT_CODES = ['intro', 'ask', 'glad', 'handoff', 'handoff_off', 'no_match', 'contact_ask', 'contact_again', 'contact_thanks'];
const CHOICES = ['yes', 'no', 'person'];

export function botLine(author: ChatAuthor, body: string): { as: ChatAuthor; text: string } | null {
  const at = body.indexOf(':');
  const kind = at < 0 ? body : body.slice(0, at);
  const code = at < 0 ? '' : body.slice(at + 1);
  if ((author === 'bot' || author === 'system') && kind === 'bot' && BOT_CODES.includes(code)) return { as: 'bot', text: t(`cb.${code}` as MessageKey) };
  if (author === 'system' && kind === 'choice' && CHOICES.includes(code)) return { as: 'visitor', text: t(`cb.choice_${code}` as MessageKey) };
  if (author === 'bot') return { as: 'bot', text: body };
  return null;
}

/** The label on one of the assistant's buttons. */
export const choiceLabel = (c: { key: string; label: string | null }) => c.label ?? (CHOICES.includes(c.key) ? t(`cb.choice_${c.key}` as MessageKey) : c.key);
